<template>
	<div class="m-audio">
		<audio 
			ref="audio"
			:src="src"
			@loadedmetadata="onLoadedmetadata"
			@canplay="onCanplay"
			@timeupdate="onTimeupdate">
			您的浏览器版本过低，不识别audio标签
		</audio>
		<span 
			:class="['status', status ? 'play' : 'pause']"
			@click="onToggle">
		</span>
		<span class="time-c">{{currentTime_f}}</span>
		<span 
			ref="bar" 
			class="bar"
			@click="onBarClick($event)">
			<span class="buffer" :style="{width: bw_f}"></span>
			<span class="progress" :style="{width: pw_c_f}"></span>
			<span 
				ref="dot" 
				class="dot" 
				:style="{left: dl_f}"
				@touchstart="onStart($event)"
				@touchmove="onMove($event)"
				@touchend="onEnd($event)">
			</span>
		</span>
		<span class="time-t">{{duration_f}}</span>
	</div>
</template>

<script>

function timeFormat(time) {
	let t1 = Math.floor(time / 60);
	let t2 = Math.floor(time % 60);
	if(t1 < 10) {
		t1 = "0" + t1;
	}
	if(t2 < 10) {
		t2 = "0" + t2;
	}
	return t1 + ":" + t2;
}

export default {
	props: {
		src: {
			type: String,
			default: ""
		}
	},
	data: function() {
		return {
			// 播放状态(0:暂停; 1:播放中)
			status: 0,
			// 播放进度
			currentTime: 0,
			// 时长
			duration: 0,
			// 缓冲区域的宽度
			bw: 0,
			// 进度条总宽度
			pw_t: 0,
			// 播放进度宽度
			pw_c: 0,
			// 拖放点的宽度
			dw: 0,
			// 拖放点距进度条左侧的距离
			dl: 0,
			// 是否正在拖动
			moving: false
		};
	},
	computed: {
		currentTime_f: function() {
			return timeFormat(this.currentTime);
		},
		duration_f: function() {
			return timeFormat(this.duration);
		},
		bw_f: function() {
			return this.bw + "px";
		},
		pw_c_f: function() {
			return this.pw_c + "px";
		},
		dl_f: function() {
			return this.dl + "px";
		}
	},
	mounted: function() {
		this.pw_t = this.$refs.bar.offsetWidth;
		this.dw = this.$refs.dot.offsetWidth;
		this.dl = - this.dw / 2;
	},
	methods: {
		/** 监听loadedmetadata，更新音频时长 */
		onLoadedmetadata: function() {
			let audio = this.$refs.audio;
			let readyState = audio.readyState;
			let duration = audio.duration;
			if((readyState === 1 || readyState === 4) && duration && duration !== 1) {
				this.duration = duration;
			}
		},
		/** 监听canplay事件，更新缓冲进度 */
		onCanplay: function() {
			let vm = this;
			let audio = vm.$refs.audio;
			let bufferTimer = setInterval(function() {
				if(audio.buffered == undefined) {
					return;
				}
				let bufferIndex = audio.buffered.length;
				if(bufferIndex > 0) {
					vm.bw = audio.buffered.end(bufferIndex - 1) / audio.duration * vm.pw_t;
					if(Math.abs(audio.duration - audio.buffered.end(bufferIndex - 1)) < 1) {
						vm.bw = vm.pw_t;
						clearInterval(bufferTimer);
					}
				}
			});
		},
		/** 监听timeupdate，更新播放进度 */
		onTimeupdate: function() {
			let audio = this.$refs.audio;
			let duration = audio.duration;
			let currentTime = audio.currentTime;
			if(currentTime != 0 & !isNaN(duration)) {
				if(!this.duration) {
					this.duration = duration;
				}
				this.currentTime = currentTime;
				this.pw_c = currentTime / duration * this.pw_t;
				if(!this.moving) {
					this.dl = this.pw_c - this.dw / 2;
				}
				if(audio.ended) {
					this.resetPlayer();
				}
			}

		},
		/** 监听播放按钮的点击事件，切换播放状态 */
		onToggle: function() {
			let audio = this.$refs.audio;
			if(isNaN(audio.duration)) {
				return;
			}
			this.status = this.status ? 0 : 1;
			this.status === 1 ? audio.play() : audio.pause();
		},
		/** 监听拖动开始 */
		onStart: function($event) {
			if(!this.bw) {
				return;
			}
			this.moving = true;
			this.dot_sx = $event.targetTouches && $event.targetTouches.length ? $event.targetTouches[0].pageX : $event.pageX;
			this.dl_s = this.dl;
		},
		/** 监听拖动中 */
		onMove: function($event) {
			this.dot_nx = $event.targetTouches && $event.targetTouches.length ? $event.targetTouches[0].pageX : $event.pageX;
			let range = this.dot_nx - this.dot_sx;
			if(range > 0) {
				if((this.dl_s + range) < this.pw_t) {
					this.dl = this.dl_s + range;
				}
				else {
					this.dl = this.pw_t - this.dw / 2;
				}
			}
			else if(range < 0) {
				if((this.dl_s + range) < 0) {
					this.dl = - this.dw / 2;
				}
				else {
					this.dl = this.dl_s + range;
				}
			}
		},
		/** 监听拖动结束 */
		onEnd: function($event) {
			let audio = this.$refs.audio;
			let duration = audio.duration;
			audio.currentTime = (this.dl / this.pw_t) * duration;
			this.moving = false;
		},
		/** 监听进度条点击事件 */
		onBarClick: function($event) {
			if(!this.bw) {
				return;
			}
			let audio = this.$refs.audio;
			let duration = audio.duration;
			this.dl = $event.clientX - this.$refs.bar.getBoundingClientRect().left;
			audio.currentTime = this.dl / this.pw_t *duration;
		},
		/** 重置播放器 */
		resetPlayer: function() {
			let audio = this.$refs.audio;
			this.currentTime = 0;
			this.pw_c = 0;
			this.dl = - this.dw / 2;
			this.status = 0;
			audio.pause();
		}
	}
}

</script>

<style lang="less">
.m-audio {
	position: relative;
	width: 100%;
	height: 30px;
	border-radius: 2px;
	font-size: 12px;
	color: #fff;
	background: rgba(0, 0, 0, 0.8);
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	user-select: none;
	audio {
		display: none;
	}
	span {
		display: inline-block;
		vertical-align: middle;
	}
	.status {
		display: inline-block;
		float: left;
		width: 30px;
		height: 30px;
		background-repeat: no-repeat;
		background-position: center center;
		background-size: 100%;
		&.play {
			background-image: url(../../images/audio/icon_play.png);
		}
		&.pause {
			background-image: url(../../images/audio/icon_pause.png);
		}
	}
	.time-c {
		float: left;
		line-height: 30px;
	}
	.time-t {
		float: right;
		line-height: 30px;
		margin-right: 10px;
	}
	.bar {
		position: absolute;
		left: 70px;
		right: 50px;
		top: 13px;
		height: 4px;
		border-radius: 2px;
		background: #aaa;
		.buffer, .progress {
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;
			border-radius: 2px;
		}
		.buffer {
			background: #eee;
			z-index: 2;
		}
		.progress {
			background: #c33;
			z-index: 3;
		}
		.dot {
			position: absolute;
			width: 12px;
			height: 12px;
			top: 50%;
			margin-top: -6px;
			background: url(../../images/audio/icon_dot.png) no-repeat center center;
			background-size: auto 100%;
			z-index: 4;
		}
	}
}
</style>


// WEBPACK FOOTER //
// audio-bar.vue?0e16ca2c